import { useContext, useEffect, useRef, useState } from "react";
import client from "../../../contentfulClient";
import { MainContext } from "../../../MainContext";
import scrollMonitor from "scrollmonitor";
import anime from "animejs/lib/anime.es.js";
import useScrollAnimation from "../../useAnimationScrolling";

export const LinguisticServices = () => {
    const {
        linguisticServices,
        staticTexts: { lingustic: staticTexts },
        staticTexts: { learnMoreButton: learnMoreButton },
        cardRefs,
        openModal,
        lang
    } = useContext(MainContext);

    const animationConfig = {
        scale: [0.2, 1],
        opacity: [0, 1],
        duration: 1000,
        easing: "easeOutExpo",
    };

    useScrollAnimation(cardRefs, animationConfig, linguisticServices);

    return (
        <div
            className="linguistic-container"
            ref={(el) => {
                if (el) cardRefs.current[linguisticServices.length + 1] = el;
            }}
        >
            <div className="banner" style={{ backgroundImage: `url(${staticTexts.image})` }}>
                <div className="box">
                    <h2 className="title">{staticTexts.title}</h2>
                    <p className="subTitle">{staticTexts.subTitle}</p>
                    <div className="btn-gray" onClick={() => openModal({ ...staticTexts })}>
                        {learnMoreButton.text}
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="grid">
                    {linguisticServices.reverse().map((service: any, index: number) => (
                        <div
                            className="service-card"
                            ref={(el) => {
                                if (el) cardRefs.current[index] = el;
                            }}
                            key={index}
                            lang={lang}
                        >
                            <img src={`${service.image}`} alt="" className="image" />
                            <div lang={lang} className="right">
                                <div className="texts">
                                    <h3 className="title">{service.title}</h3>
                                    <p className="service-description">{service.subTitle}</p>
                                </div>
                                <div className="btn-gray" onClick={() => openModal({ ...service })}>
                                    {learnMoreButton.text}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
